import React, { useEffect } from "react";
import { CardHeader, CardContent, CardActions, } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { Modal } from 'antd';

const CustomModal = (props) => {
    const { open, handleOpen, handleClose, title, subTitle, bodyModal, buttonActions, formSubmit, size, centrado } = props;

    useEffect(() => {
        if (open)
            if (handleOpen)
                handleOpen();
    }, [open]);

    return (
        <Modal
            title={
                <CardHeader
                    avatar={
                        <Avatar sx={{ width: 25, height: 25, bgcolor: "#00009e", }}>
                            <EngineeringIcon sx={{ fontSize: '1.2rem' }} />
                        </Avatar>
                    }
                    title={<div style={{ fontSize: '11px' }}>{title}</div>}
                    subheader={<div style={{ fontSize: '9px', fontStyle: 'italic' }}>{subTitle}</div>}
                    sx={{
                        paddingBottom: '0.3rem',
                        paddingTop: 0,
                        margin: '-0.5rem -1rem -0.1rem -1rem',
                        borderBottom: `solid 0.05rem #005f36`,
                    }}
                />
            }
            open={open}
            onOk={handleClose}
            onCancel={handleClose}
            destroyOnClose={true}
            footer={null}

            // style={{ top: (centrado ? '20%' : 50) }}
            style={{ top: '10%', }}
            width={(size === 'lg' ? 1000 : size === 'md' ? 800 : 500)}
        >
            <form onSubmit={formSubmit} >
                <CardContent
                    sx={{
                        padding: 0,
                        margin: '0 -0.5rem',
                    }}
                >
                    {bodyModal}
                </CardContent>

                <CardActions
                    sx={{
                        margin: '0.5rem -0.5rem -1rem -1rem',
                        borderTop: `solid 0.05rem rgba($color: #005f36, $alpha: 0.5)`,
                        display: 'flex',
                        justifyContent: 'flex-end'
                    }}
                >
                    {buttonActions}
                    <button
                        key={'btn-save'}
                        className='btn btn-sm btn-danger'
                        type="button"
                        onClick={handleClose}
                    >
                        Cerrar
                    </button>
                </CardActions>
            </form>
        </Modal >
    )
}

export default CustomModal;